"use client";

import { useConsent } from "@vllnt/analytics/react";
import { Button } from "@vllnt/ui";
import { useTranslations } from "next-intl";

export function CookiePreferences() {
  const t = useTranslations("privacy");
  const { consent, hasResponded, resetConsent } = useConsent();

  return (
    <div className="border-2 border-foreground p-6">
      <h2 className="text-xl font-semibold mb-4">
        {t("cookies.preferences_title")}
      </h2>

      <div className="space-y-4">
        <div className="flex items-center justify-between py-2 border-b border-border">
          <div>
            <p className="font-medium">{t("cookies.essential_title")}</p>
            <p className="text-sm text-muted-foreground">
              {t("cookies.essential_description")}
            </p>
          </div>
          <span className="text-sm text-muted-foreground">
            {t("cookies.always_active")}
          </span>
        </div>

        <div className="flex items-center justify-between py-2 border-b border-border">
          <div>
            <p className="font-medium">{t("cookies.analytics_title")}</p>
            <p className="text-sm text-muted-foreground">
              {t("cookies.analytics_description")}
            </p>
          </div>
          <span className="text-sm">
            {hasResponded
              ? consent?.analytics
                ? t("cookies.enabled")
                : t("cookies.disabled")
              : t("cookies.not_set")}
          </span>
        </div>

        <div className="pt-4">
          <Button onClick={resetConsent} variant="outline">
            {t("cookies.reset_preferences")}
          </Button>
          <p className="text-sm text-muted-foreground mt-2">
            {t("cookies.reset_description")}
          </p>
        </div>
      </div>
    </div>
  );
}
